import TimeSegment from './TimeSegment'

const PostCountDownElite = ({ firstPlanMonth = 1 }: { firstPlanMonth: number }) => {
  return (
    <div>
      <h2 className='text-[22px] text-orange10 text-left'>Your rebalancing plan is delayed</h2>
      <div className='flex justify-evenly items-center bg-white rounded-2xl shadow-[2px_2px_0_0#CC5C2D] mb-6 mt-6'>
        <TimeSegment value={0} label='days' isFirst={true} />
        <TimeSegment value={0} label='hours' />
        <TimeSegment value={0} label='minutes' />
        <TimeSegment value={0} label='seconds' />
      </div>
      <p className='text-base text-orange10 text-left'>
        We need a little extra time to prepare your Power Rebalancing plan. We'll update you as soon as it's ready.
      </p>
    </div>
  )
}

export default PostCountDownElite
